import {ReceiptExpensesType} from "@/enums/type";
import {ReceiptExpensePickingListPayStatus} from "@/enums/status";

export class ReceiptPickingListParams {
    code?: string;
    page = 1;
    limit = 10;
    type = ReceiptExpensesType.PickingListCollect;
    targetType?: number;
    targetRowGuid?: string;
    createdByRowGuid?: string;
    fromDate?: number;
    toDate?: number;
    statusPayment?: ReceiptExpensePickingListPayStatus;
}
